import React, { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { addEditMessageTemplate } from '../../../store/messagetemplate/actions';
import Select from 'react-select';
import { MessageDropDownOption } from "../../../components/admin/message-dropdown-option";
import { getAllAutomatedTemplateKey } from '../../../api/messagetemplateapi';

function addEditTemplates({ show, onClose, modelmessageTemplate, lastSegment }) {
    const dispatch = useDispatch();
    const [messageTemplateData, setMessageTemplateData] = useState(modelmessageTemplate);
    const [error, setError] = useState(null);
    const [errorName, setErrorName] = useState(null);
    const [errorEnglish, setErrorEnglish] = useState(null);
    const [options, setOptions] = useState([]);
    const { isAdmin } = useSelector((state) => state.auth);

    const [selectedOption, setSelectedOption] = useState(null);
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const textareaRef = useRef(null);
    const handleOptionClick = (label) => {
        console.log(label);
        //navigator.clipboard.writeText(label)
        //.then(() => {
        //    console.log(`Copying data: ${label}`);
        //})
        //.catch((err) => {
        //    console.error('Unable to copy to clipboard', err);
        //});
        setMenuIsOpen(false);
        textareaRef.current.focus();
    };

    useEffect(() => {
        getAllAutomatedTemplateKey().then((response) => {
            if (response?.data?.success) {
                const formattedData = response.data.data.map(item => ({
                    value: item.id,
                    label: item.name
                }));
                setOptions(formattedData);
            }
        });
    }, []);

    useEffect(() => {
        setMessageTemplateData(modelmessageTemplate);
    }, [modelmessageTemplate]);

    const handleOnClose = () => {
        setError(null)
        setErrorName(null)
        setErrorEnglish(null)
        setMessageTemplateData(modelmessageTemplate);
        onClose();
    };
    const handleSave = () => {

        if (
            typeof messageTemplateData.name === 'string' &&
            typeof messageTemplateData.englishContent === 'string' &&
            messageTemplateData.name.trim() !== '' &&
            messageTemplateData.englishContent.trim() !== ''
        ) {
            const data = {
                "id": messageTemplateData.id,
                "name": messageTemplateData.name,
                "messagetypeid": messageTemplateData.messageTypeId ?? 4,
                "templatecontentcode": messageTemplateData.templateContentCode ?? '',
                "englishcontent": messageTemplateData.englishContent,
                "spanishcontent": messageTemplateData.spanishContent ?? '',
                "baseId": messageTemplateData.baseId
            };

            dispatch(addEditMessageTemplate(data))
                .then((response) => {
                    if (response.payload.success) {
                        setMessageTemplateData(null);
                        setError(null);
                        setErrorName(null);
                        setErrorEnglish(null);
                        onClose();
                    } else {
                        setError(response.payload.message);
                    }
                });

        } else {
            setError(null);
            setErrorName(typeof messageTemplateData.name !== 'string' || messageTemplateData.name.trim() === '' ? 'Name is required.' : null);
            setErrorEnglish(typeof messageTemplateData.englishContent !== 'string' || messageTemplateData.englishContent.trim() === '' ? 'English Content is required.' : null);
            setMessageTemplateData((prevData) => ({
                ...prevData,
                name: typeof messageTemplateData.name !== 'string' || messageTemplateData.name.trim() === '' ? '' : prevData.name,
                englishContent:
                    typeof messageTemplateData.englishContent !== 'string' ||
                        messageTemplateData.englishContent.trim() === ''
                        ? '' : prevData.englishContent
            }));
        }
    };

    const handleKeyDown = useCallback((event) => {
        if (event.key === 'Escape') {
            handleOnClose();
        }
    }, [handleOnClose]);

    useEffect(() => {
        if (show) {
            document.addEventListener('keydown', handleKeyDown);
        } else {
            document.removeEventListener('keydown', handleKeyDown);
        }

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [show, handleKeyDown]);

    if (!show) {
        return null;
    }
   
    return (
        <div className="admin-modal-overlay select-group-modal message-edit-modal">
            <div className="admin-modal admin-add-role modal-header-border">
                <button className="admin-modal-close modal-close" onClick={handleOnClose}>
                    <span className="material-symbols-rounded">close</span>
                </button>
                <h2 className="admin-modal-heading text-center">Add/Edit Message</h2>
                <div className="admin-modal-scroll">
                    <div className="message-title-row flex-center justify-content-between">
                        <div className="message-template-form-box">
                            <label className="light-grey">Message Title</label>
                            <div>
                                <input type="text"
                                    className="edit-message-input w-100 message-title"
                                    value={messageTemplateData?.name ?? ''}
                                    onChange={(e) => {
                                        setMessageTemplateData({ ...messageTemplateData, name: e.target.value });
                                        setErrorName(null)
                                    }}
                                    readOnly={!isAdmin || lastSegment === "automatedmessagetemplate"}
                                ></input>
                                {errorName && <p className="error-messagess">{errorName}</p>}
                            </div>
                        </div>
                        {(lastSegment === "automatedmessagetemplate" && messageTemplateData?.name !=='Auto Reply for Reschedule') &&
                            <div className="message-template-form-box">
                                <label className="light-grey">Available Variables</label>
                                <Select
                                    className="select-copy-option"
                                    defaultValue={selectedOption}
                                    onChange={(value) => {
                                        setSelectedOption(value);
                                        setMenuIsOpen(false);
                                    }}
                                    options={options}
                                    isSearchable={false}
                                    menuIsOpen={menuIsOpen}
                                    onFocus={() => setMenuIsOpen(true)}
                                    onBlur={() => setMenuIsOpen(false)}
                                    components={{
                                        Option: (props) => <MessageDropDownOption {...props} onClick={handleOptionClick} />,
                                        DropdownIndicator: null,
                                    }}
                                    menuShouldScrollIntoView={false}
                                />
                            </div>
                        }
                    </div>
                    
                    <div className="message-template-form-box english-message">
                        <label className="light-grey">Message Content (English)</label>
                        <div>
                            <textarea
                                ref={textareaRef} 
                                className="edit-message-input w-100"
                                value={messageTemplateData?.englishContent ?? ''}
                                onChange={(e) => {
                                    setMessageTemplateData({ ...messageTemplateData, englishContent: e.target.value });
                                    setErrorEnglish(null)
                                }}
                                readOnly={!isAdmin}>
                            </textarea>
                            {errorEnglish && <p className="error-messagess">{errorEnglish}</p>}
                        </div>

                    </div>
                    <div className="message-template-form-box">
                        <label className="light-grey">Message Content (Spanish)</label>
                        <div>
                            <textarea
                                className="edit-message-input w-100"
                                value={messageTemplateData?.spanishContent ?? ''}
                                onChange={(e) => {
                                    setMessageTemplateData({ ...messageTemplateData, spanishContent: e.target.value });
                                }}
                                readOnly={!isAdmin}>
                            </textarea>
                        </div>

                    </div>
                    
                </div>
                <div className="admin-modal-button-wrap">
                    {error && <p className="error-messagess">{error}</p>}
                    {isAdmin && <button className="admin-modal-button power" onClick={handleSave}>
                        Save
                    </button>}                    
                </div>
            </div>
        </div>
    );
}
export default addEditTemplates;

addEditTemplates.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    modelmessageTemplate: PropTypes.obj,
    lastSegment: PropTypes.string
};